import { useQuery } from "@tanstack/react-query";
import "./styles/homecategory.css";
import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Link } from "react-router-dom";
import { MdArrowBackIosNew, MdArrowForwardIos } from "react-icons/md";
import { motion } from "framer-motion";

const HomeCategory = () => {
  const baseUrl = process.env.REACT_APP_API_URL;

  const fetchCategories = async () => {
    const token = localStorage.getItem("token");
    const res = await fetch(`${baseUrl}catagorylist`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) throw new Error("Failed to fetch categories");
    return res.json();
  };

  const { data: categories = [] } = useQuery({
    queryKey: ["categories-list"],
    queryFn: fetchCategories,
  });

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <section className="category-home-section pt-5 pb-0">
      <div className="container position-relative">
        <div className="section-header mb-5 d-flex align-items-center justify-content-between">
          <h3 className="h3 fw-bold mb-0">Browse by Category</h3>
          <div className="category-navigation d-flex gap-2">
            <button ref={prevRef} className="category-nav-btn prev">
              <MdArrowBackIosNew />
            </button>
            <button ref={nextRef} className="category-nav-btn next">
              <MdArrowForwardIos />
            </button>
          </div>
        </div>

        <Swiper
          grabCursor={true}
          spaceBetween={30}
          speed={800}
          onInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
          }}
          breakpoints={{
            0: { slidesPerView: 3, spaceBetween: 15 },
            576: { slidesPerView: 4, spaceBetween: 20 },
            768: { slidesPerView: 5, spaceBetween: 30 },
            1024: { slidesPerView: 6, spaceBetween: 40 },
          }}
          modules={[Navigation]}
          className="category-swiper"
        >
          {categories?.catagories?.map((category, index) => (
            <SwiperSlide key={category._id}>
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
              >
                <Link
                  state={{ isScroll: true }}
                  to={`/category/${category._id}`}
                  className="category-card-item"
                >
                  <div className="category-icon-wrapper">
                    <img
                      className="category-icon"
                      src={category.image ? `${category.image}` : "https://cdn-icons-png.flaticon.com/128/763/763072.png"}
                      alt={category.catagoryname}
                    />
                  </div>
                  <span className="category-name">{category.catagoryname}</span>
                </Link>
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default HomeCategory;

